'use client';

import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import HeroSectionStyle from './style';
import CustomImage from '@/components/Image';
import { Text } from '@weareconceptstudio/core';
import TitleAnim from '@/animation';
import { withDataContext } from '@/context';
import { arrows } from './utils';

const HeroSection = ({ external_title, external_description, external_desktop_image, external_mobile_image, globalData, isArrows = true }) => {
	const { title, incentives_description, desktop_image, mobile_image } = globalData.incentives;
	const [load, setLoad] = useState(false);

	const innerSectionRef = useRef(null);
	const innerContentRef = useRef(null);

	const titleRef = useRef(null);
	const descriptionRef = useRef(null);

	useEffect(() => {
		if (typeof window === 'undefined') return;
		if (!load) return;

		if (innerSectionRef.current) {
			gsap.fromTo(
				innerSectionRef.current,
				{ opacity: 0 },
				{
					opacity: 1,
					duration: 0.6,
					ease: 'power2.out',
				}
			);
		}
	}, [load]);

	return (
		<HeroSectionStyle className='hero-section'>
			<TitleAnim
				animRef={titleRef}
				startedAnim={load}
			/>

			<TitleAnim
				animType='subtitle'
				animRef={descriptionRef}
				configAnim={{ delay: 0.3 }}
				startedAnim={load}
			/>

			<div
				ref={innerSectionRef}
				className='hero-inner-section opacity-zero'>
				<CustomImage
					priority
					double={[external_desktop_image || desktop_image, external_mobile_image || mobile_image]}
					className='hero-image'
					onLoad={() => setLoad(true)}
				/>

				<div
					id='hero-section'
					className='hero-content'>
					<div className='top-block'>
						<div className='hero-inner-content'>
							<div
								ref={innerContentRef}
								className='inner-outer-wrapper'>
								<Text
									ref={titleRef}
									className={`h1 white-1000 montserrat-400 hero-title opacity-animation `}>
									{external_title || title}
								</Text>

								<Text
									ref={descriptionRef}
									className={`p p1 white-1000 montserrat-500 hero-desc opacity-animation `}>
									{external_description || incentives_description}
								</Text>
							</div>
						</div>

						<div className={'empty-col'} />
					</div>
				</div>
			</div>

			{isArrows && arrows}
		</HeroSectionStyle>
	);
};

export default withDataContext(HeroSection, ['globalData']);
